<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <!-- <ComingSoon /> -->
      <div class="statics mt-4">
        <div class="row">
          <!-- عدد المنشآت -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="box">
              <div class="icon">
                <i class="fas fa-building"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("PLACEHOLDERS.provider_count") }}</span>
                <p class="number_box">
                  {{ formatNumber(statics.provider_count) }}
                </p>
              </div>
            </div>
          </div>

          <!-- عدد طلبات انضمام المنشآت -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="box">
              <div class="icon">
                <i class="fas fa-user-plus"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("PLACEHOLDERS.providers_requests") }}</span>
                <p class="number_box">
                  {{ formatNumber(statics.providers_requests) }}
                </p>
              </div>
            </div>
          </div>

          <!-- عدد المستخدمين -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="box">
              <div class="icon">
                <i class="fas fa-users"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("PLACEHOLDERS.users_count") }}</span>
                <p class="number_box">
                  {{ formatNumber(statics.users_count) }}
                </p>
              </div>
            </div>
          </div>

          <!-- عدد المستخدمين المشتركين في الباقات -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="box">
              <div class="icon">
                <i class="fas fa-box"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("PLACEHOLDERS.user_has_packages") }}</span>
                <p class="number_box">
                  {{ formatNumber(statics.user_has_packages) }}
                </p>
              </div>
            </div>
          </div>

          <!-- عدد المستخدمين في التجربة المجانية -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="box">
              <div class="icon">
                <i class="fas fa-gift"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("PLACEHOLDERS.free_trail_users") }}</span>
                <p class="number_box">
                  {{ formatNumber(statics.free_trail_users) }}
                </p>
              </div>
            </div>
          </div>

          <!-- إجمالي الإيرادات -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="box">
              <div class="icon">
                <i class="fas fa-money-bill-wave"></i>
              </div>
              <div class="info_box">
                <span>{{ $t("PLACEHOLDERS.total_profit") }}</span>
                <p class="number_box">
                  {{ formatCurrency(statics.total_profit) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->
  </div>
</template>

<script>
import ComingSoon from "@/components/ui/ComingSoon.vue";

export default {
  name: "HomePage",

  components: {
    ComingSoon,
  },

  data() {
    return {
      statics: {
        providers_requests: 0,
        provider_count: 0,
        users_count: 0,
        user_has_packages: 0,
        free_trail_users: 0,
        total_profit: 0,
      },
    };
  },

  methods: {
    formatNumber(value) {
      return value ? value.toLocaleString("ar-SA") : "0";
    },

    formatCurrency(value) {
      if (!value) return "0 ريال";
      const formatted = parseFloat(value).toLocaleString("ar-SA", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return `${formatted} ريال`;
    },
    async getStatics() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "Home",
        });

        // console.log("All Data ==>", res.data.data);
        this.statics = res.data.data;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows
  },

  mounted() {
    this.getStatics();
  },
};
</script>

<style lang="scss" scoped>
.show_all_content_wrapper .statics .box .info_box {
  align-items: flex-start !important;
  width: 100% !important;
  padding-inline-start: 5% !important;
}
.show_all_content_wrapper {
  .statics {
    .box {
      height: 100%;
      background: #f7941e;
      padding: 25px;
      margin-bottom: 10px;
      border-radius: 5px;
      align-items: flex-start;
      overflow: hidden;
      display: flex;
      justify-content: space-between;

      //cursor: pointer;
      transition: all 0.5s;

      &:hover {
        background: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

        .icon {
          i {
            color: #f7941e;
          }
        }
        .info_box {
          span,
          p.number_box {
            color: #000;
          }
        }
      }

      .icon {
        height: 60px;
        min-width: 60px;
        width: 60px;
        border-radius: 60px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 25px;
          color: #000;
        }
      }

      .info_box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        span {
          font-size: 19px;
          color: #fff;
        }

        p.number_box {
          font-size: 30px;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
